import { gql } from '@apollo/client';

export const entitlementDetails = gql`
  fragment entitlementDetail on CloudSiteProduct {
    accountId
    id
    sen
    edition
    editionKey
    trial
    firstPeriodStartDate
    latestPeriodStartDate
    latestPeriodEndDate
    productId
    productName
    billingStatus
    endTimestamp
    isCloud
    cloudSiteUrl
    billingFrequency
    entitlementNumber
    trialStartDate
    trialEndDate
    nextBillingTimestamp
    userTier
    transactionAccountNumber
    transactionAccountId
    invoiceGroupId
    billedUsers
    billingCycle
    isSandbox
    isApp
    isAddOn
    provisioningStatus
    activeUsers
    logoId
    planType
    offering {
      name
      relationshipRequirements {
        side
        level
        type
      }
    }
    upgradeTrial {
      offeringName
      offeringId
      baseOfferingName
    }
    scheduledChanges {
      subscriptionScheduleAction
    }
    pricingPlan {
      id
      type
      tiers {
        floor
        ceiling
        amount
        unitAmount
        flatAmount
      }
    }
    isExternallyBilled
    relatesFromEntitlements {
      relationshipType
    }
  }
`;

const productAppSubscription = gql`
  ${entitlementDetails}
  fragment productAppSubscriptionForOrganization on ProductAppSubscriptionForCloudSite {
    products {
      ...entitlementDetail
    }
    apps {
      ...entitlementDetail
    }
  }
`;

/**
 * Below query fetches the cloud site products for an organization using organization id.
 * If the organization id is not provided,
 * query look for cloud site products using cloud site id.
 */

export const fetchCloudSiteProductAppAndSubscriptionsForOrganization = gql`
  ${productAppSubscription}
  query fetchCloudSiteProductAppAndSubscriptionsForOrganization(
    $parentSen: String
    $cloudSiteId: String
    $organizationId: String
    $transactionAccountId: String
    $filterOptions: [FilterOption]
  ) {
    cloudSiteProductsAppsAndSubscriptionsForOrganization(
      parentSen: $parentSen
      cloudSiteId: $cloudSiteId
      organizationId: $organizationId
      transactionAccountId: $transactionAccountId
      filterOptions: $filterOptions
    ) {
      jira {
        ...productAppSubscriptionForOrganization
      }
      statuspage {
        ...productAppSubscriptionForOrganization
      }
      confluence {
        ...productAppSubscriptionForOrganization
      }
      other {
        ...productAppSubscriptionForOrganization
      }
    }
  }
`;
